export default __webpack_public_path__ + "static/Starbust5-0d1cd0f28f58a886aaeb813b1a220d72.png";